import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const VIP_KEY = "panduh_vip_code";
export const getVip = () => {
  try { return localStorage.getItem(VIP_KEY) || ""; } catch { return ""; }
};
export const setVip = (code) => {
  try { localStorage.setItem(VIP_KEY, code); } catch { /* ignore */ }
  window.dispatchEvent(new Event("vip-change"));
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
};

export const imgSrc = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export const sectionOf = (m) => m?.section || (m?.founder ? "founder" : "crew");

export const VIP_SHOW_DISCOUNT = 5;
export const vipPrice = (price) => Math.max(Number(price ?? 0) - VIP_SHOW_DISCOUNT, 0);

export const money = (n) => `$${Number(n ?? 0).toFixed(Number(n) % 1 ? 2 : 0)}`;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
  else el.scrollIntoView({ behavior: "smooth" });
};
